// src/jira/issue-type/types.ts
var JiraIssueTypeAriResourceOwner = "jira", JiraIssueTypeAriResourceType = "issue-type";

export {
  JiraIssueTypeAriResourceOwner,
  JiraIssueTypeAriResourceType
};
